var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-input',_vm._g(_vm._b({ref:"input",class:_vm.css,attrs:{"dense":"","hide-details":"auto","input":'input'}},'v-input',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }